import React, { Component } from 'react'


// @material-ui/core components
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// @material-ui/icons
import CheckIcon from "@material-ui/icons/Check";
import CheckBoxOutlineIcon from "@material-ui/icons/CheckBoxOutlined";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import _ from "lodash";

import style from "./DXFormStyles";

import {
  dangerColor,
} from "assets/jss/material-dashboard-pro-react.jsx";

export default class DXFormInputCheckbox extends Component {
  render() {
    const {
      pid,
      question,
      valueState,
      setFormValueState
    } = this.props;

    const id = `${pid}.${question.id}`;

    const { titleStyle = { sm: 2 } } = question;
    const { sm } = titleStyle;

    return <GridContainer key={id} justify='center'>
      <GridItem xs={12} sm={sm}>
        <h4 style={style.infoText}>
          {question.title}
        </h4>
      </GridItem>
      <GridItem xs={12} sm={12 - sm}>
        {
          question.options.map(({ title, value }) => <FormControlLabel
            key={value}
            control={
              <Checkbox
                checked={_.get(valueState, id).includes(value)}
                disabled={setFormValueState === null}
                onChange={e => {
                  var currentValue = _.get(valueState, id);
                  if (currentValue.constructor.name === "String") {
                    currentValue = [];
                  }
                  if (e.target.checked) {
                    if (question.constraints) {
                      question.constraints.forEach(constraint => {
                        const { type, value: v } = constraint;
                        if (type === 'mutualExclusive') {
                          if (v.includes(value)) {
                            currentValue = _.difference(currentValue, v);
                          }
                        }
                      });
                    };
                    currentValue.push(value);
                  } else {
                    currentValue = currentValue.filter((el, index) => {
                      return value !== el;
                    })
                  }
                  setFormValueState(id, currentValue);
                  setFormValueState(`${id}State`, 'success')
                }}
                value={value}
                name="check button"
                aria-label={title}
                icon={
                  <CheckBoxOutlineIcon
                    style={style.checkBoxUnchecked}
                  />
                }
                checkedIcon={
                  <CheckIcon
                    style={style.checkBoxChecked}
                  />
                }
              />
            }
            label={title}
          />
          )
        }
        {
          _.get(valueState, `${id}State`) === 'error'
            ? <h4 style={{ ...style.labelRoot, ...style.labelRootError, color: dangerColor[0] }}>필수</h4>
            : null
        }
      </GridItem>
    </GridContainer >

  }
}
